import React from 'react';
import { Span, Truncate } from 'src/shared/design-system/Text';
import { Font } from 'web-common/src/shared/styles';

export const DishTitle: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Truncate lines={2}>
    <Span size='20px' mobileSize='20px' margin='0' weight={Font.Weight.NORMAL} lineHeight='25px'>
      {children}
    </Span>
  </Truncate>
);
